import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Legend } from 'recharts';
import type { BlockDistribution, FloorDistribution } from '@/lib/admin/analytics';

interface BlockFloorDistributionProps {
  blockData: BlockDistribution[];
  floorData: FloorDistribution[];
}

const chartConfig = {
  available: {
    label: 'Available',
    color: 'hsl(197, 24%, 44%)', // brand-teal
  },
  reserved: {
    label: 'Reserved',
    color: 'hsl(197, 30%, 55%)', // champagne-light
  },
  sold: {
    label: 'Sold',
    color: 'hsl(213, 29%, 26%)', // brand-navy
  },
};

export function BlockFloorDistribution({ blockData, floorData }: BlockFloorDistributionProps) {
  const blockChartData = blockData.map((item) => ({
    block: `Block ${item.block}`,
    Available: item.available,
    Reserved: item.reserved,
    Sold: item.sold,
  }));

  const floorChartData = floorData.map((item) => ({
    floor: item.floor,
    Available: item.available,
    Reserved: item.reserved,
    Sold: item.sold,
  }));

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Block Distribution</CardTitle>
          <CardDescription>Units by block</CardDescription>
        </CardHeader>
        <CardContent>
          <ChartContainer
            config={chartConfig}
            className="h-[250px] w-full"
          >
            <BarChart data={blockChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="block" />
              <YAxis />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Legend />
              <Bar dataKey="Available" fill="var(--color-available)" />
              <Bar dataKey="Reserved" fill="var(--color-reserved)" />
              <Bar dataKey="Sold" fill="var(--color-sold)" />
            </BarChart>
          </ChartContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Floor Distribution</CardTitle>
          <CardDescription>Units by floor level</CardDescription>
        </CardHeader>
        <CardContent>
          <ChartContainer
            config={chartConfig}
            className="h-[250px] w-full"
          >
            <BarChart data={floorChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="floor" />
              <YAxis />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Legend />
              <Bar dataKey="Available" fill="var(--color-available)" />
              <Bar dataKey="Reserved" fill="var(--color-reserved)" />
              <Bar dataKey="Sold" fill="var(--color-sold)" />
            </BarChart>
          </ChartContainer>
        </CardContent>
      </Card>
    </div>
  );
}

